import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import useScrollToTop from '../../hooks/useScrollToTop';
import * as AppPropTypes from '../../lib/PropTypes';

import EventHeader from '../headers/Event';
import CarouselList from '../lists/CarouselList';
import Body from '../partials/Body';
import BookingDetails from '../partials/BookingDetails';
import FilmDetails from '../partials/FilmDetails';
import Partners from '../partials/Partners';
import People from '../partials/People';

import styles from '../../../styles/pages/event.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const EventPage = ({ page, className }) => {
    const { url, description = null, related = null, event = null } = page;
    const { film = null, filmBundle = null, partners = null, people = null } = event || {};
    const { films: bundleFilms = [] } = filmBundle || {};
    const films = film !== null ? [film] : bundleFilms || [];

    useScrollToTop(url);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <EventHeader item={event} />
            <div className={classNames(styles.section, styles.details)}>
                <div className={classNames(styles.inner, styles.detailsInner)}>
                    <BookingDetails
                        className={styles.bookingDetails}
                        events={[event]}
                        buttonIsDark
                    />
                    <div>
                        {film === null && description !== null ? (
                            <Body className={styles.eventDetails} body={description} />
                        ) : null}
                        {people !== null ? (
                            <People className={styles.people} people={people} />
                        ) : null}
                        {partners !== null && partners.length > 0 ? (
                            <Partners className={styles.partners} partners={partners} />
                        ) : null}
                    </div>
                    <div className={styles.films}>
                        {films.map((item, itemIndex) => (
                            <FilmDetails
                                key={`film-${itemIndex + 1}`}
                                className={styles.filmDetails}
                                item={item}
                            />
                        ))}
                    </div>
                </div>
            </div>
            {related !== null ? (
                <div className={styles.suggestions}>
                    <div className={styles.inner}>
                        <CarouselList
                            title={
                                <FormattedMessage
                                    defaultMessage="Other suggestions"
                                    description="Carousel heading"
                                />
                            }
                            items={related}
                            cardProps={{ isStacked: true }}
                            className={styles.carousel}
                            slotClassName={styles.carouselSlot}
                            cardClassName={styles.carouselCard}
                        />
                    </div>
                </div>
            ) : null}
        </div>
    );
};
EventPage.propTypes = propTypes;
EventPage.defaultProps = defaultProps;

export default EventPage;
